export default __webpack_public_path__ + "static/cafe_36038-c12265ca7eb681f56bdafd713abb8393.png";